import React, {useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';
import ShareDialog from './ShareDialog';

const useStyles = makeStyles({
  root: {
    minWidth: 280,
    maxWidth: 300
  }
});


const cutString = (str, i = 70) => {
  if (!str || str.length < i) return str;

  str = str.substring(0, i);

  const lastIndex = str.lastIndexOf(" ");

  str = str.substring(0, lastIndex);

  return str = str + "..."

}

const NewsCard = ({news, isDetails, onDelete}) => {

  const history = useHistory();
  const pathname = history?.location?.pathname;
  const isAdminModule = pathname === '/app/admin';

  const userDetails = useSelector(state => state.userDetails);
  const roleName = userDetails?.roleName;
  const isAdmin = roleName?.includes('ADMIN');

  const [open, setOpen] = useState(false);

  let {image, title, textData, id} = news ? news : {};

  textData = isDetails ? textData : cutString(textData);

  textData = textData ? parse(textData) : '';
  //console.log(image)

  image = image ? image.data ? URL.createObjectURL(image.data) : image : ''; // TO CHECK

  const classes = useStyles();

  //const sttr = "<ol><li>&nbsp; Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging</li><li>&nbsp; across all continents except Antarctica</li></ol>";

  const deleteNewsId = () => {
    onDelete(news.id);
  }

  const goBack = () => {
    return history.goBack();
  }

  const goToDetails = () => {
    if(isAdminModule ) return;
    history.push(`/news-details/${news?.id}`);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <Card className={isDetails ? "news-card" : classes.root}>
      <CardActionArea  onClick={goToDetails}>
        <CardMedia
          component="img"
          alt="News Image"
          height={isDetails ? null : "200"}
          image={image}
          onClick={goToDetails}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          {/*

          <Typography variant="body2" color="textSecondary" component="p">
          Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
            across all continents except Antarctica
          </Typography>
            */}
          <div variant="body2" color="textSecondary" className='news-text-data'>
            {textData}
          </div>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button size="small" color="primary" disabled={isAdminModule}>
        {isDetails 
           ? <span onClick={goBack}>Go Back</span>
           : <Link to={`/news-details/${news?.id}`} >Learn More</Link>} 
        </Button>
        {isDetails ? <Button size="small" color="primary" onClick={handleClickOpen}>
          Share
        </Button> : null}
        <ShareDialog open={open} onClose={handleClose} newsId={news?.id}/>
        {isDetails && isAdmin ? <Button size="small" color="primary" onClick={deleteNewsId}>
          Delete news
        </Button> : null}
      </CardActions>
    </Card>
  );
}

export default NewsCard



